/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

import logoSvg from '../../svg/agrolog_logo.svg';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function EmailVerificationController($stateParams, $state, $translate, toast, loginService) {
    var vm = this;

    vm.logoSvg = logoSvg;

    vm.resendEmail = resendEmail;

    function resendEmail() {
        loginService.resendEmailActivation($stateParams.email).then(function success() {
            $state.go('signup.emailVerification', {email: $stateParams.email});
        }, function fail() {
        });
    }

}